import { useContext, useState } from "react";
import CartContext from "../../context/cart";
import { downloadDocument } from "../../utils/documents";
import Icon from "../icon";
import BoxWrapper from "./box-wrapper";

const PickUpSubmit = () => {
  const {
    labels,
    survey: { attachments },
    cartRequest,
  } = useContext(CartContext);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadDelega = async () => {
    setIsDownloading(true);
    const delegaDoc = attachments?.find(
      (att) => att.fileName.split(".")[0] === "WELFARE_CART_MODULO_DELEGA"
    );
    await downloadDocument(delegaDoc);
    setIsDownloading(false);
  };

  return (
    <>
      {cartRequest?.deliveryOption === "PUNTO_VENDITA" && (
        <>
          <div className="carrello-content__file">
            <h3>
              {labels?.WELFARE_SHOPPING_CART_DELEGATION_FORM ||
                "Modulo delega Carrello della spesa"}
            </h3>
            <button type="button" className="link link--accent" onClick={downloadDelega}>
              {labels?.DOWNLOAD || "Download"}
              {isDownloading ? <span className="loading-spinner" /> : <Icon name="download" />}
            </button>
          </div>
          <hr />
        </>
      )}
      <BoxWrapper readOnly={cartRequest?.deliveryOption !== "PUNTO_VENDITA"} />
    </>
  );
};

export default PickUpSubmit;
